module.exports = __webpack_public_path__ + "img/followBg1.c355862a.png";